export const rqDefaultOptions = {
  //   retry: 1, //number of retries , will stay in loadign state during retries
  // retry:0 // no retries
  //   retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 40000),
  refetchOnWindowFocus: false, //enables and disables fetch on refocus
  // staleTime: 1000, // query will refetch on focus after 5 seconds
}
